var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var PropertyInteractionModel = require("./../propertyViewer/propertyInteractionModel.js");

var ShapeWrapperInteractionModel = function (data, editorModel) {
    var self = this;

    editor_2d.AbstractSelectableInteractionModel.call(this, data, editorModel);
    this.editorModel = editorModel;

    this.shapeInteractionModel = this.value("shapeInteractionModel", false);

    if(this.data.shape()) this.buildShapeInteractionModel();

    this.data.shape.onChange(this, function (value, old) {
        if(value) self.buildShapeInteractionModel();
    });
};
lib_core.inherit(ShapeWrapperInteractionModel, editor_2d.AbstractSelectableInteractionModel);
ShapeWrapperInteractionModel.$class = "ShapeWrapperInteractionModel";

module.exports = ShapeWrapperInteractionModel;

ShapeWrapperInteractionModel.prototype.buildShapeInteractionModel = function () {
    var self = this;

    var constructor;
    switch (this.data.shape().constructor) {
        case cio_datamodel.RectangleData:
            constructor = editor_2d.RectangleInteractionModel;
            break;
        case cio_datamodel.EllipseData:
            constructor = editor_2d.EllipseInteractionModel;
            break;
        case cio_datamodel.TriangleData:
            constructor = editor_2d.TriangleInteractionModel;
            break;
        case cio_datamodel.PathData:
            constructor = editor_2d.PathInteractionModel;
            break;
        case cio_datamodel.LineData:
            constructor = editor_2d.LineInteractionModel;
            break;
        case cio_datamodel.TextData:
            constructor = editor_2d.TextInteractionModel;
            break;
        case cio_datamodel.PropertyData:
            constructor = PropertyInteractionModel;
            break;
    }
    var interactionModel = new constructor(this.data.shape(), this.editorModel);
    this.shapeInteractionModel(interactionModel);
    this.editorModel.interactionModelDataMap.put(this.data.shape(), interactionModel); // needs to be alive

    this.data.shape().onRemove(this, function () {
        self.remove();
    });
};

ShapeWrapperInteractionModel.prototype.setSelected = function (selected) {
    editor_2d.AbstractSelectableInteractionModel.prototype.setSelected.apply(this, arguments);
    if(this.shapeInteractionModel()) this.shapeInteractionModel().setSelected.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.setFocus = function (focus) {
    editor_2d.AbstractSelectableInteractionModel.prototype.setFocus.apply(this, arguments);
    if(this.shapeInteractionModel()) this.shapeInteractionModel().setFocus.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.hidden = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().hidden.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.pos = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().pos.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.angle = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().angle.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.width = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().width.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.height = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().height.apply(this.shapeInteractionModel(), arguments);
};

ShapeWrapperInteractionModel.prototype.rotate = function () {
    if(this.shapeInteractionModel()) return this.shapeInteractionModel().rotate.apply(this.shapeInteractionModel(), arguments);
};
